import api from "../api";

const endpoint = {
	fetchMenuImages: () => api.get("/menu"),
};

export default endpoint;
